import * as React from 'react';
import { ApplicationContext } from '../../reactContexts/applicationContext';
import { SuburbanFinCalculator } from '../../SuburbanComponents/SuburbanFinCalculator';
import { ISuburbanCalculatorData } from '../../types/suburban';
import { DEFAULT_CALCULATOR_CONFIG } from './constants';

export const SuburbanFinCalculatorContainer = () => {
  const { config } = React.useContext(ApplicationContext);

  const data = React.useMemo(() => {
    const { interestRateSuggests, ...rest } =
      config.get<ISuburbanCalculatorData>('mortgageLanding.suburbanCalculatorData') || DEFAULT_CALCULATOR_CONFIG;

    return { ...rest, interestRateSuggests: JSON.stringify(interestRateSuggests) };
  }, [config]);

  return <SuburbanFinCalculator config={data} />;
};
